import { render, staticRenderFns } from "./o-menu.vue?vue&type=template&id=34fa9056&scoped=true&"
import script from "./o-menu.vue?vue&type=script&lang=js&"
export * from "./o-menu.vue?vue&type=script&lang=js&"
import style0 from "./o-menu.vue?vue&type=style&index=0&id=34fa9056&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fa9056",
  null
  
)

export default component.exports